export const LabAdminTabConfig = [
  { label: "Dashboard", path: "/admin-dashboard" },
  { label: "Scan Sample", path: "/scan-sample" },
  { label: "Scheduler", path: "/scheduler" },
  { label: "Tasks", path: "/tasks" },
  { label: "Requested List", path: "/requested" },
  { label: "Reports", path: "/reports" },
   { label: "Historical Data", path: "/historical-data" },
];

export const LabAnalystTabConfig = [
  { label: "Dashboard", path: "/analyst-dashboard" },
  { label: "Scan Sample", path: "/analyst-scan-sample" },
  { label: "Scheduler", path: "/analyst-scheduler" },
  { label: "Tasks", path: ["/analyst-tasks/myassignment", "/analyst-tasks/peer-review"] },
  { label: "Requested List", path: "/analyst-requested" },
  { label: "Reports", path: "/analyst-reports" },
];
export const AnalystCompanyManagementTabConfig = [
  { label: "Company Management", path: "/analyst-company-management" },
];
export const CompanyManagementTabConfig = [
  { label: "Company Management", path: "/company-management" },
];

export const CustomerReportTabConfig = [
  { label: "Customer Report", path: "/customer-reports" },
];
export const AssayRequestTabConfig = [
  { label: "Assay Request Record", path: "/assay-request-record" },
];
